module.exports = __webpack_public_path__ + "static/media/2017_conf_The_5_PM_Personas.52e160d2.png";